import * as React from 'react';

/* eslint-disable react-hooks/exhaustive-deps */
export function useDidMount(callback: () => void): void {
  React.useEffect((): ReturnType<typeof callback> => callback(), []);
}
/* eslint-enable react-hooks/exhaustive-deps */
